export default __webpack_public_path__ + "static/media/meta.c0548bf3.svg";